const AVATAR_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" width="100%" height="100%" role="img"><circle cx="40" cy="40" r="40" fill="#d7dee7"/><circle cx="40" cy="32" r="14" fill="#7d8b9c"/><path fill="#7d8b9c" d="M12 72c4-18 14-26 28-26s24 8 28 26v8H12z"/></svg>';

const AVATAR_URI = `data:image/svg+xml,${encodeURIComponent(AVATAR_SVG)}`;

export function employeePhotoUrl(code) {
  if (code == null || String(code).trim() === '') return AVATAR_URI;
  return `https://api-hr.boonsiri.co.th/public/images/profile/${encodeURIComponent(String(code))}_1.jpg`;
}

export function cartoonSvg() {
  return AVATAR_SVG;
}

export function cartoonDataUri() {
  return AVATAR_URI;
}
